import { Button, Form } from "react-bootstrap";
import { useState } from "react";
import Message from "../message";

function SellersScraper() {
  const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

  const [sellersFile, set_sellersFile] = useState("");
  const [status_sellersFile, setStatus_sellersFile] = useState("");

  const submit_sellersFile = async () => {
    setStatus_sellersFile("");

    if (sellersFile.length <= 0) {
      setStatus_sellersFile("Upload Delivery Excel File!");
    } else {
      setStatus_sellersFile("Processing Files...");

      const formDatasellersFile = new FormData();
      formDatasellersFile.append("file", sellersFile);

      const requestOptions = {
        method: "POST",
        body: formDatasellersFile,
      };

      try {
        const sellersFile_response = await fetch(
          apiServer + `api/sellers_scraper/upload_file/`,
          requestOptions
        );
        const sellersFile_status_id = await sellersFile_response.json();
        const sellersFile_status = sellersFile_status_id.detail
          ? sellersFile_status_id.detail
          : sellersFile_status_id;
        setStatus_sellersFile(sellersFile_status);
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Form.Control
        type="file"
        name="verifier"
        id="verifier"
        className="verifierxcls"
        onChange={(e) => set_sellersFile(e.target.files[0])}
      />
      <Button
          style={{
            marginTop: "1.25rem",
            marginRight: "1rem",
            backgroundColor: "#3a4c7a",
            border: "none",
          }}
          href="./templates/seller_scraper.xlsx"
          download
        >
          Download Template
        </Button>
      <Button
        variant="primary"
        type="button"
        style={{ marginTop: "20px" }}
        onClick={() => submit_sellersFile()}
      >
        Submit
      </Button>

      {Message(status_sellersFile, setStatus_sellersFile)}
    </div>
  );
}
export default SellersScraper;
